export const serviceTypes = [
  { value: "educational", label: "منصة تعليمية" },
  { value: "clinic", label: "تطبيق عيادات للأطباء" },
  { value: "center-attendance", label: "سيستم حضور وانصراف للسنتر" },
  { value: "dine", label: "نظام إدارة المطاعم والكافيهات" },
  { value: "ecommerce", label: "متجر إلكتروني" },
  { value: "mobile", label: "تطبيق موبايل" },
  { value: "portfolio", label: "بورتفوليو / موقع شخصي" },
  { value: "ai-bot", label: "نظام AI للمبيعات" },
  { value: "custom", label: "مشروع مخصص" },
] as const

export type ServiceType = (typeof serviceTypes)[number]["value"]
